import { render, staticRenderFns } from "./ageRangeRate.vue?vue&type=template&id=2036bf09&"
import script from "./ageRangeRate.vue?vue&type=script&lang=js&"
export * from "./ageRangeRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports